import { HTMLAttributes } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '../../../../common/button-new';
import { Modal } from '../../../../common';
import { ReferralModalRegistrationProps } from './referral-modal-registration.models';
import { useStyles } from './referral-modal-registration.styles';
import { cx } from '../../../../../utils';
import { StepsList } from '../steps-list';
import { v2026PP12192 } from '../../../../../constants/veeva';

export const ReferralModalRegistration = ({ onClose, ...props }: ReferralModalRegistrationProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Modal
      {...props}
      onClose={onClose}
      PaperProps={{
        'data-testid': 'referral-modal-registration',
      } as HTMLAttributes<HTMLDivElement>}
      propsContentStyles={classes.content}
      propsPaperStyles={classes.paper}
      veevaNumber={v2026PP12192}
      isVeevaSmall
      content={(
        <>
          <h2 className={cx('title-medium', classes.title)} data-testid="referral-registration-title">
            <FormattedMessage id="referral.modal.registration.title" />
          </h2>
          <StepsList isRegistered={false} />
          <Button
            testId="start-registration"
            onClick={() => onClose?.()}
            style="dark"
            rootClasses={classes.button}
            fullWidth
          >
            <FormattedMessage id="referral.modal.registration.button" />
          </Button>
        </>
      )}
    />
  );
};
